require('jquery');

export class Section
{
	element;
	key;

	constructor(element)
	{
		let self = $(element);
		this.element = element;
		this.key = this.element.dataset.key || this.element.id || null;

		self.data('Section', self.data('Section') || this);
		Section[this.key] = Section[this.key] || this;
	}

	present()
	{
		this.element.present();
		return this;
	}

	allInputs()
	{
		return $(this.element).allInputs();
	}

	enableBody()
	{
		$(this.element).find('.card-body').removeClass('disabled');
		return this;
	}

	disableBody()
	{
		$(this.element).find('.card-body').addClass('disabled');
		return this;
	}

	setValid()
	{
		$(this.element).addClass('valid');
		return this;
	}

	setNotValid()
	{
		$(this.element).removeClass('valid');
		return this;
	}

	get nextSection()
	{
		return $(this.element).next('.x-section').data('Section') || null;
	}

	static enumerate()
	{
		$('.x-section').each((i, elem) =>
		{
			(new Section(elem));
		});
	}
}

window.Section = Section;

$(Section.enumerate);
